'use client';
import React from 'react';
import logo from './../../../assests/images/otp-expiry.jpg';
import '../../../assests/css/otp.css';
import { useNavigate } from 'react-router-dom';
import InlineSpinner from '../../Layout/InlineSpinner';
import { useState } from 'react';

const Expiry = (): React.JSX.Element => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  function backtoLogin() {
    navigate('/');
  }
  return (
    <div className="modal fade show d-block" tabIndex={-1} role="dialog" style={{ padding: '0px' }}>
      <div className="modal-dialog preview-pop-up" role="document">
        <div className="glass-effect h-100">
          <div className="modal-content rolemockup h-100 justify-content-center">
            <div className="mockup-container">
              <div className="screen-lap">
                {loading && (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: '100%', height: '100%' }}
                  >
                    <InlineSpinner size="medium" color="white" />
                  </div>
                )}
                <img
                  style={{ objectFit: 'contain', width: '100%', height: '100%' }}
                  src={logo}
                  alt="Image on mobile screen"
                  className="mobile-image"
                  onLoad={() => setLoading(false)} // Hide loader when image loads
                  onError={() => setLoading(false)} // Hide loader if image fails to load
                />
              </div>
              <div className="d-flex justify-content-center align-items-center otp-back-btn">
                <button type="button" onClick={backtoLogin}>
                  Back to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expiry;
